<template>
  <age-requirement>
    <v-facebook-login
      :app-id="app_id"
      @click="clicked = true"
      @sdk-init="handleSdkInit"
      @login="getUserData"
    />
  </age-requirement>
</template>

<script>
import VFacebookLogin from 'vue-facebook-login-component';
import AgeRequirement from './AgeRequirement.vue';

export default {
  name: 'FacebookLogin',
  components: {
    AgeRequirement,
    VFacebookLogin,
  },
  data() {
    return {
      FB: undefined,
      scope: undefined,
      clicked: false,
      app_id: process.env.VUE_APP_FACEBOOK_APP_ID,
    };
  },
  methods: {
    async loginFacebookUser(facebookUser) {
      this.formSubmitting = true;

      const postData = facebookUser;

      const responseData = await this.api({
        url: 'users/facebookLogin/',
        method: 'POST',
        json: postData,
      });

      this.formSubmitting = false;

      if (responseData.status === 200) {
        this.$store.commit('userData', responseData.body);

        if (this.$route.name !== 'home') {
          this.$router.push(this.$route.query.next || { name: 'home' });
        }
      } else if (responseData.status === 400) {
        this.$emit('error', responseData.body);
      } else {
        this.formErrors = {
          non_field_errors: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
    getUserData() {
      if (this.clicked) {
        this.FB.api('/me', 'GET', { fields: 'id,name,email,picture' },
          (user) => {
            const facebookUser = {
              personalID: user.id,
              name: user.name,
              email: user.email,
              picture: user.picture.data.url,
            };

            this.loginFacebookUser(facebookUser);
            this.clicked = false;
          });
      }
    },
    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      this.scope = scope;
    },
  },
};
</script>
